import * as React from 'react';
import { Button } from 'styleguide-react';
import { t } from '../../helper/locale';
import './OptionsPage.scss';
import { getChromeRuntime } from '../../chrome/wrappers';
import { ChromeMessageType } from '../../types';

export const OptionsPage = () => {
  const [isUploading, setIsUploading] = React.useState(false);
  const [statusMessage, setStatusMessage] = React.useState('');
  const [isSuccess, setIsSuccess] = React.useState(false);

  const handleUploadLogs = async () => {
    try {
      setIsUploading(true);

      const response = await getChromeRuntime().sendMessage({
        type: ChromeMessageType.UPLOAD_LOGS_AND_CLEANUP,
      });

      if (response.success) {
        setStatusMessage(t('Diagnostic successfully uploaded!'));
        setIsSuccess(true);
      } else {
        setStatusMessage(t('Diagnostic upload failed'));
        setIsSuccess(false);
      }
    } catch (error) {
      console.error(error);
      setStatusMessage(t('Diagnostic upload failed'));
      setIsSuccess(false);
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="OptionsPage">
      <div className="OptionsPage__content">
        <div className="OptionsPage__actions">
          <Button
            testId="upload-diagnostics-button"
            className="OptionsPage__upload-button rck-btn"
            onClick={handleUploadLogs}
            disabled={isUploading}
            loading={isUploading}
          >
            {t('Send diagnostics to Qustodio')}
          </Button>
        </div>

        {statusMessage && (
          <div
            className={`OptionsPage__status ${
              isSuccess
                ? 'OptionsPage__status--success'
                : 'OptionsPage__status--error'
            }`}
          >
            {statusMessage}
          </div>
        )}
      </div>
    </div>
  );
};
